export default __webpack_public_path__ + "static/media/menu2.fc2176d7.png";